[
    {
        "description": "Hole Survey - Azimuth",
        "source": "WELL_AZIMUTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "Azimuth",
        "displayName": "Azimuth",
        "category": "Hole Survey"
    },
    {
        "description": "Hole Survey - Azimuth Build Rate",
        "source": "WELL_AZIM_BUILD_RATE variable from 'postRec.cfw' file",
        "type": "string",
        "name": "AzimuthBuildRate",
        "displayName": "Azimuth Build Rate",
        "category": "Hole Survey"
    },
    {
        "description": "BHA - Max Outer Diameter",
        "source": "TOOL_OD variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "BHAMaxOD",
        "displayName": "Max Outer Diameter",
        "category": "BHA"
    },
    {
        "description": "BHA - Min Inner Diameter",
        "source": "TOOL_ID variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "BHAMinID",
        "displayName": "Min Inner Diameter",
        "category": "BHA"
    },
    {
        "description": "BHA - POOH Max Outer Diameter",
        "source": "POOH_TOOL_MAX_OD variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "BHAPOOHMaxOD",
        "displayName": "POOH Max Outer Diameter",
        "category": "BHA"
    },
    {
        "description": "BHA - POOH Min Inner Diameter",
        "source": "POOH_TOOL_MIN_ID variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "BHAPOOHMinID",
        "displayName": "POOH Min Inner Diameter",
        "category": "BHA"
    },
    {
        "description": "BHA - POOH Total Length",
        "source": "POOH_TOOL_TOTAL_LENGTH variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "BHAPOOHTotalLength",
        "displayName": "POOH Total Length",
        "category": "BHA"
    },
    {
        "description": "BHA - POOH Total Weight",
        "source": "POOH_TOOL_TOTAL_WEIGHT variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "BHAPOOHTotalWeight",
        "displayName": "POOH Total Weight",
        "category": "BHA"
    },
    {
        "description": "BHA - Total Length",
        "source": "TOOL_LENGTH variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "BHATotalLength",
        "displayName": "Total Length",
        "category": "BHA"
    },
    {
        "description": "BHA - Total Weight",
        "source": "TOOL_WEIGHT variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "BHATotalWeight",
        "displayName": "Total Weight",
        "category": "BHA"
    },
    {
        "description": "Well Parameters - Bottom Hole Static Temparature",
        "coilCatDisplayName": "CoilLife Job History - BHT",
        "source": "BHST variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "BottomHoleStaticTemperature",
        "displayName": "BHST",
        "category": "Wellbore"
    },
    {
        "description": "Operating system build code on the machine used to run Job Uploader",
        "source": "Generated by Job Uploader from client machine registry / environment variables",
        "type": "string",
        "name": "BuildCode",
        "displayName": "OS Build Code",
        "category": "Computer"
    },
    {
        "description": "Coiled Tubing - Cable Diameter",
        "source": "CABLE_OD variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "CableDiameter",
        "displayName": "Cable Diameter",
        "category": "Coiled Tubing"
    },
    {
        "description": "Coiled Tubing - Cable Weight",
        "source": "CABLE_WT_PER_LENGTH variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "CableWeight",
        "displayName": "Cable Weight",
        "category": "Coiled Tubing"
    },
    {
        "description": "Casing - Burst Pressure",
        "source": "CASING_BURST_PRESS variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CasingburstPressure",
        "displayName": "Burst Pressure",
        "category": "Casing"
    },
    {
        "description": "Casing - Collapse Pressure",
        "source": "CASING_COLLAPSE_PRESS variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CasingCollapsePressure",
        "displayName": "Collapse Pressure",
        "category": "Casing"
    },
    {
        "description": "Casing - Inner Diameter",
        "source": "CASING_ID variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CasingID",
        "displayName": "Inner Diameter",
        "category": "Casing"
    },
    {
        "description": "Casing - Outer Diameter",
        "source": "CASING_OD variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CasingOD",
        "displayName": "Outer Diameter",
        "category": "Casing"
    },
    {
        "description": "Casing - Weight",
        "source": "CASING_WT_PER_LENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CasingWeight",
        "displayName": "Weight",
        "category": "Casing"
    },
    {
        "description": "iDistrict job client",
        "displayName": "Client",
        "source": "iDistrict API",
        "type": "string",
        "name": "Client",
        "category": "Job"
    },
    {
        "description": "Job - Client",
        "displayName": "Client",
        "coilCatDisplayName": "Client",
        "source": "COMPANY variable from 'postRec.cfw' file",
        "type": "string",
        "name": "ClientCfw",
        "category": "Job"
    },
    {
        "description": "Coiled Tubing - Density",
        "source": "COIL_DENSITY variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CoilDensity",
        "displayName": "Density",
        "category": "Coiled Tubing"
    },
    {
        "description": "Coiled Tubing - Inner Diameter",
        "source": "COIL_ID variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CoilID",
        "displayName": "Inner Diameter",
        "category": "Coiled Tubing"
    },
    {
        "description": "CoilCAT build",
        "source": "'_CoilCAT_Version.txt' file",
        "type": "string",
        "name": "CoilCatBuild",
        "displayName": "CoilCAT build",
        "category": "Computer"
    },
    {
        "description": "CoilCAT version",
        "source": "'_CoilCAT_Version.txt' file",
        "type": "string",
        "name": "CoilCatVersion",
        "displayName": "CoilCAT version",
        "category": "Computer"
    },
    {
        "description": "Coiled Tubing - Section Length",
        "source": "COIL_LENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CoilLength",
        "displayName": "Section Length",
        "category": "Coiled Tubing"
    },
    {
        "description": "Coiled Tubing - Young's Modulus",
        "source": "COIL_MODULUS variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CoilModulus",
        "displayName": "Young's Modulus",
        "category": "Coiled Tubing"
    },
    {
        "description": "Coiled Tubing - Outer Diameter",
        "source": "COIL_OD variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CoilOD",
        "displayName": "Outer Diameter",
        "category": "Coiled Tubing"
    },
    {
        "description": "Coiled Tubing - Weight",
        "source": "COIL_WT_PER_LENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CoilWeight",
        "displayName": "Weight",
        "category": "Coiled Tubing"
    },
    {
        "description": "Coiled Tubing - Yield Strength",
        "source": "COIL_YIELD_STRENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CoilYieldStrength",
        "displayName": "Yield Strength",
        "category": "Coiled Tubing"
    },
    {
        "description": "Windows computer name of the machine used to run Job Uploader",
        "source": "Generated by Job Uploader from client machine registry / environment variables",
        "type": "string",
        "name": "ComputerName",
        "displayName": "Machine Name",
        "category": "Computer"
    },
    {
        "description": "iDistrict job country",
        "displayName": "Country",
        "source": "iDistrict API",
        "type": "string",
        "name": "Country",
        "category": "Well Info"
    },
    {
        "description": "Well Info - Country",
        "displayName": "Country",
        "source": "COUNTRY variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CountryCfw",
        "category": "Well Info"
    },
    {
        "description": "Well Info - County / Parish",
        "source": "COUNTY_OR_PARISH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CountyOrParish",
        "displayName": "County / Parish",
        "category": "Well Info"
    },
    {
        "description": "BHA - Young's Modulus",
        "source": "CTBHA_MODULUS variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CtbhaModulus",
        "displayName": "Young's Modulus",
        "category": "BHA"
    },
    {
        "description": "BHA - Yield Strength",
        "source": "CTBHA_YIELD_STRENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "CtbhaYieldStrength",
        "displayName": "Yield Strength",
        "category": "BHA"
    },
    {
        "description": "Well Info - District",
        "source": "DS_LOCATION variable from 'postRec.cfw' file",
        "type": "string",
        "name": "DistrictLocation",
        "displayName": "District",
        "category": "Well Info"
    },
    {
        "description": "Hole Survey - Dogleg Severity",
        "source": "WELL_DOGLEG_SEVERITY variable from 'postRec.cfw' file",
        "type": "string",
        "name": "DoglegSeverity",
        "displayName": "Dogleg Severity",
        "category": "Hole Survey"
    },
    {
        "description": "Well Info - Engineer Name",
        "source": "DS_ENGINEER variable from 'postRec.cfw' file",
        "type": "string",
        "name": "EngineerName",
        "displayName": "Engineer Name",
        "category": "Well Info"
    },
    {
        "description": "Well Info - Field Name",
        "displayName": "Field",
        "coilCatDisplayName": "Field",
        "source": "FIELD_NAME variable from 'postRec.cfw' file",
        "type": "string",
        "name": "FieldName",
        "category": "Well Info"
    },
    {
        "description": "Well Info - Formation Name",
        "source": "FORMATION_NAME variable from 'postRec.cfw' file",
        "type": "string",
        "name": "FormationName",
        "displayName": "Formation Name",
        "category": "Well Info"
    },
    {
        "description": "Wellsite Configuration - Gooseneck Length",
        "coilCatDisplayName": "Gooseneck - Length (L)",
        "source": "RDB_GOOSENECK_LENGTH variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "GooseneckLength",
        "displayName": "Gooseneck Length",
        "category": "Surface Setup"
    },
    {
        "description": "Wellsite Configuration - Gooseneck Radius",
        "coilCatDisplayName": "Gooseneck - Radius (R)",
        "source": "RDB_GOOSENECK_RAD variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "GooseneckRadius",
        "displayName": "Gooseneck Radius",
        "category": "Surface Setup"
    },
    {
        "description": "Wellsite Configuration - Ground to Center of Reel",
        "coilCatDisplayName": "Ground to Center of Reel (Z)",
        "source": "RDB_WELLHEAD_TO_CENTER_REEL variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "GroundToCenterOfReel",
        "displayName": "Ground to Center of Reel",
        "category": "Surface Setup"
    },
    {
        "description": "Wellsite Configuration - Ground to Top of Injector",
        "coilCatDisplayName": "Ground to Top of Injector (Y)",
        "source": "RDB_WELLHEAD_INJECTOR variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "GroundToTopOfInjector",
        "displayName": "Ground to Top of Injector",
        "category": "Surface Setup"
    },
    {
        "description": "Well Parameters - H2S Level",
        "coilCatDisplayName": "CoilLIFE Job History - H2S Level",
        "source": "H2S variable from 'postRec.cfw' file",
        "type": "string",
        "name": "H2sLevel",
        "displayName": "H2S Level",
        "category": "Wellbore"
    },
    {
        "description": "Well Parameters - Hole Size",
        "source": "BIT_DIA variable from 'postRec.cfw' file",
        "type": "string",
        "name": "HoleSize",
        "displayName": "Hole Size",
        "category": "Wellbore"
    },
    {
        "description": "Wellsite Configuration - Injector Head Type",
        "displayName": "Injector Head Type",
        "coilCatDisplayName": "Injector Head Type",
        "source": "INJ_HD_TYPE variable from 'postRec.cfw' file",
        "type": "string",
        "name": "InjectorHeadType",
        "category": "Surface Setup"
    },
    {
        "description": "Wellsite Configuration - Injector Head Weight",
        "source": "INJ_HD_WEIGHT variable from 'postRec.cfw' file",
        "type": "string",
        "name": "InjectorHeadWeight",
        "displayName": "Injector Head Weight",
        "category": "Surface Setup"
    },
    {
        "description": "Job - Job Description",
        "displayName": "Job Description",
        "coilCatDisplayName": "Description",
        "source": "RDB_JOB_TYPE variable from 'postRec.cfw' file",
        "type": "string",
        "name": "JobDescription",
        "category": "Job"
    },
    {
        "description": "Name of the job folder on the CoilCAT machine",
        "source": "Generated by Job Uploader",
        "type": "string",
        "name": "JobFolderName",
        "displayName": "Job Folder Name",
        "category": "Computer"
    },
    {
        "description": "Job - Job ID",
        "displayName": "Treatment #",
        "coilCatDisplayName": "Treatment #",
        "source": "RDB_JOB_IDENTIFICATION variable from 'postRec.cfw' file",
        "type": "string",
        "name": "JobID",
        "category": "Job"
    },
    {
        "description": "Well Info - Latitude (Deg.)",
        "source": "LATITUDE_DEG variable from 'postRec.cfw' file",
        "type": "string",
        "name": "LatitudeDeg",
        "displayName": "Latitude (Deg.)",
        "category": "Wellbore"
    },
    {
        "description": "Well Info - Latitude (Direction)",
        "source": "LATITUDE_DIRECTION variable from 'postRec.cfw' file",
        "type": "string",
        "name": "LatitudeDirection",
        "displayName": "Latitude (Direction)",
        "category": "Wellbore"
    },
    {
        "description": "Well Info - Latitude (Min.)",
        "source": "LATITUDE_MIN variable from 'postRec.cfw' file",
        "type": "string",
        "name": "LatitudeMin",
        "displayName": "Latitude (Min.)",
        "category": "Wellbore"
    },
    {
        "description": "Well Info - Latitude (Sec.)",
        "source": "LATITUDE_SEC variable from 'postRec.cfw' file",
        "type": "string",
        "name": "LatitudeSec",
        "displayName": "Latitude (Sec.)",
        "category": "Wellbore"
    },
    {
        "description": "Restrictions - Length",
        "source": "RestrictionLength variable from 'postRec.cfw' file",
        "type": "string",
        "name": "Length",
        "displayName": "Length",
        "category": "Restrictions"
    },
    {
        "description": "Well Info - Longitude (Deg.)",
        "source": "LONGITUDE_DEG variable from 'postRec.cfw' file",
        "type": "string",
        "name": "LongitudeDeg",
        "displayName": "Longitude (Deg.)",
        "category": "Wellbore"
    },
    {
        "description": "Well Info - Longitude (Direction)",
        "source": "LONGITUDE_DIRECTION variable from 'postRec.cfw' file",
        "type": "string",
        "name": "LongitudeDirection",
        "displayName": "Longitude (Direction)",
        "category": "Wellbore"
    },
    {
        "description": "Well Info - Longitude (Min)",
        "source": "LONGITUDE_MIN variable from 'postRec.cfw' file",
        "type": "string",
        "name": "LongitudeMin",
        "displayName": "Longitude (Min)",
        "category": "Wellbore"
    },
    {
        "description": "Well Info - Longitude (Sec)",
        "source": "LONGITUDE_SEC variable from 'postRec.cfw' file",
        "type": "string",
        "name": "LongitudeSec",
        "displayName": "Longitude (Sec)",
        "category": "Wellbore"
    },
    {
        "description": "Coiled Tubing - Material",
        "displayName": "Material",
        "coilCatDisplayName": "CT Material",
        "source": "COIL_MATERIAL variable from 'postRec.cfw' file",
        "type": "string",
        "name": "Material",
        "category": "Coiled Tubing"
    },
    {
        "description": "Casing - Measured Depth",
        "source": "CASING_DEPTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "MeasuredCasingDepth",
        "displayName": "Measured Depth",
        "category": "Casing"
    },
    {
        "description": "Tubing - Measured Depth",
        "source": "TUBING_DEPTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "MeasuredTubingDepth",
        "displayName": "Measured Depth",
        "category": "Tubing"
    },
    {
        "description": "Hole Survey - Measured Depth",
        "source": "WELL_DEPTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "MeasuredWellDepth",
        "displayName": "Measured Depth",
        "category": "Hole Survey"
    },
    {
        "description": "Operating System used to run Job Uploader",
        "source": "Generated by Job Uploader from client machine registry / environment variables",
        "type": "string",
        "name": "OperatingSystem",
        "displayName": "OS Name",
        "category": "Computer"
    },
    {
        "description": "Operating System Version used to run Job Uploader",
        "source": "Generated by Job Uploader from client machine registry / environment variables",
        "type": "string",
        "name": "OsVersion",
        "displayName": "OS Version",
        "category": "Computer"
    },
    {
        "description": "BHA - POOH Inner Diameter",
        "source": "CTBHA_POOH_ID variable from 'postRec.cfw' file",
        "type": "string",
        "name": "PoohID",
        "displayName": "POOH Inner Diameter",
        "category": "BHA"
    },
    {
        "description": "BHA - POOH Inner Diameter",
        "source": "CTBHA_POOH_OD variable from 'postRec.cfw' file",
        "type": "string",
        "name": "PoohOD",
        "displayName": "POOH Inner Diameter",
        "category": "BHA"
    },
    {
        "description": "BHA - POOH Section Length",
        "source": "CTBHA_POOH_LENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "PoohSectionLength",
        "displayName": "POOH Section Length",
        "category": "BHA"
    },
    {
        "description": "BHA - POOH Unit Length",
        "source": "CTBHA_POOH_WT_PER_LENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "PoohUnitLength",
        "displayName": "POOH Unit Length",
        "category": "BHA"
    },
    {
        "description": "BHA - POOH Weight",
        "source": "CTBHA_POOH_WEIGHT variable from 'postRec.cfw' file",
        "type": "string",
        "name": "PoohWeight",
        "displayName": "POOH Weight",
        "category": "BHA"
    },
    {
        "description": "CPU information for the machine where Job Uploader is run",
        "source": "Generated by Job Uploader from client machine registry / environment variables",
        "type": "string",
        "name": "Processor",
        "displayName": "CPU Info",
        "category": "Computer"
    },
    {
        "description": "Total RAM on the machine where Job Uploader is run",
        "source": "Generated by Job Uploader from client machine registry / environment variables",
        "type": "string",
        "name": "Ram",
        "displayName": "RAM Info",
        "category": "Computer"
    },
    {
        "description": "Coiled Tubing - Reel Name",
        "source": "RDB_REEL_IDENTIFICATION_VIEW variable from 'postRec.cfw' file",
        "type": "string",
        "name": "ReelName",
        "displayName": "Reel Name",
        "category": "Coiled Tubing"
    },
    {
        "description": "Wellsite Configuration - Reel to Injector",
        "coilCatDisplayName": "Reel to Injector (X)",
        "source": "RDB_GOOSENECK_INJECTOR variable from 'postRec.cfw' file",
        "type": "string",
        "name": "ReelToInjector",
        "displayName": "Reel to Injector",
        "category": "Surface Setup"
    },
    {
        "description": "Restrictions - Comments",
        "source": "RestrictionComment variable from 'postRec.cfw' file",
        "type": "string",
        "name": "RestrictionComments",
        "displayName": "Comments",
        "category": "Restrictions"
    },
    {
        "description": "Restrictions - ID",
        "source": "RestrictionID variable from 'postRec.cfw' file",
        "type": "string",
        "name": "RestrictionID",
        "displayName": "ID",
        "category": "Restrictions"
    },
    {
        "description": "Restrictions - MD",
        "source": "RestrictionMD variable from 'postRec.cfw' file",
        "type": "string",
        "name": "RestrictionMD",
        "displayName": "MD",
        "category": "Restrictions"
    },
    {
        "description": "Restrictions - Type",
        "source": "RestrictionName variable from 'postRec.cfw' file",
        "type": "string",
        "name": "RestrictionName",
        "displayName": "Type",
        "category": "Restrictions"
    },
    {
        "description": "Coiled Tubing - Section Volume",
        "source": "COIL_VOLUME variable from 'postRec.cfw' file",
        "type": "string",
        "name": "SectionVolume",
        "displayName": "Section Volume",
        "category": "Coiled Tubing"
    },
    {
        "description": "Coiled Tubing - Section Weight",
        "source": "COIL_WEIGHT variable from 'postRec.cfw' file",
        "type": "string",
        "name": "SectionWeight",
        "displayName": "Section Weight",
        "category": "Coiled Tubing"
    },
    {
        "description": "Well Info - State Province",
        "source": "STATE_OR_PROVINCE variable from 'postRec.cfw' file",
        "type": "string",
        "name": "StateOrProvince",
        "displayName": "State Province",
        "category": "Wellbore"
    },
    {
        "description": "CoilCAT coil string name",
        "displayName": "String Name",
        "coilCatDisplayName": "String",
        "source": "RDB_CT_IDENTIFICATION variable from 'postRec.cfw' file; RDB_RV_STRINGID variable, if RDB_CT_IDENTIFICATION is not available; Name of latest *.sdb file if both variables are missing in .cfw",
        "type": "string",
        "name": "StringName",
        "category": "Coiled Tubing"
    },
    {
        "description": "Well Parameters - Surface Temperature",
        "source": "EARTH_TEMP variable from 'postRec.cfw' file",
        "type": "string",
        "name": "SurfaceTemperature",
        "displayName": "Surface Temperature",
        "category": "Wellbore"
    },
    {
        "description": "ACTive Toolstring - Tool Length",
        "source": "TOOLSTRCONFIG_TOOL_LENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "ToolLength",
        "displayName": "Tool Length",
        "category": "ACTive Toolstring"
    },
    {
        "description": "Coiled Tubing - Total Length",
        "source": "COIL_TOTAL_LENGTH variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "TotalLength",
        "displayName": "Total Length",
        "category": "Coiled Tubing"
    },
    {
        "description": "Well Parameters - Total Measured Depth",
        "source": "WELL_TOTAL_MD variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "TotalMeasuredDepth",
        "displayName": "Total Measured Depth",
        "category": "Wellbore"
    },
    {
        "description": "Coiled Tubing - Total Volume",
        "source": "COIL_TOTAL_VOLUME variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "TotalVolume",
        "displayName": "Total Volume",
        "category": "Coiled Tubing"
    },
    {
        "description": "Coiled Tubing - Total Weight",
        "source": "COIL_TOTAL_WEIGHT variable from 'postRec.cfw' file",
        "type": "decimal?",
        "name": "TotalWeight",
        "displayName": "Total Weight",
        "category": "Coiled Tubing"
    },
    {
        "description": "Hole Survey - True Vertical Depth",
        "source": "WELL_TVD variable from 'postRec.cfw' file",
        "type": "string",
        "name": "TrueVerticalDepth",
        "displayName": "True Vertical Depth",
        "category": "Hole Survey"
    },
    {
        "description": "Tubing - Burst Pressure",
        "source": "TUBING_BURST_PRESS variable from 'postRec.cfw' file",
        "type": "string",
        "name": "TubingburstPressure",
        "displayName": "Burst Pressure",
        "category": "Tubing"
    },
    {
        "description": "Tubing - Collapse Pressure",
        "source": "TUBING_COLLAPSE_PRESS variable from 'postRec.cfw' file",
        "type": "string",
        "name": "TubingCollapsePressure",
        "displayName": "Collapse Pressure",
        "category": "Tubing"
    },
    {
        "description": "Tubing - Inner Diameter",
        "source": "TUBING_ID variable from 'postRec.cfw' file",
        "type": "string",
        "name": "TubingID",
        "displayName": "Inner Diameter",
        "category": "Tubing"
    },
    {
        "description": "Tubing - Outer Diameter",
        "source": "TUBING_OD variable from 'postRec.cfw' file",
        "type": "string",
        "name": "TubingOD",
        "displayName": "Outer Diameter",
        "category": "Tubing"
    },
    {
        "description": "Tubing - Weight",
        "source": "TUBING_WT_PER_LENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "TubingWeight",
        "displayName": "Weight",
        "category": "Tubing"
    },
    {
        "description": "BHA - Unit Weight",
        "source": "CTBHA_COMPONENT_WT_PER_LENGTH variable from 'postRec.cfw' file",
        "type": "string",
        "name": "UnitWeight",
        "displayName": "Unit Weight",
        "category": "BHA"
    },
    {
        "description": "Coiled Tubing - Wall Thickness",
        "source": "COIL_WALL_THICKNESS variable from 'postRec.cfw' file",
        "type": "string",
        "name": "WallThickness",
        "displayName": "Wall Thickness",
        "category": "Coiled Tubing"
    },
    {
        "description": "Hole Survey - Deviation",
        "source": "WELL_DEVIATION variable from 'postRec.cfw' file",
        "type": "string",
        "name": "WellDeviation",
        "displayName": "Deviation",
        "category": "Hole Survey"
    },
    {
        "description": "Hole Survey - Deviation Build Rate",
        "source": "WELL_DEV_BUILD_RATE variable from 'postRec.cfw' file",
        "type": "string",
        "name": "WellDeviationBuildRate",
        "displayName": "Deviation Build Rate",
        "category": "Hole Survey"
    },
    {
        "description": "iDistrict job ID",
        "displayName": "iDistrict/FDP ID",
        "source": "iDistrict API",
        "type": "string",
        "name": "WellID",
        "category": "Job"
    },
    {
        "description": "iDistrict Job ID",
        "displayName": "iDistrict/FDP ID",
        "coilCatDisplayName": "FDP / iDistrict Job #",
        "source": "I_DISTRICT_JOB_ID variable from 'postRec.cfw' file",
        "type": "string",
        "name": "WellIDCfw",
        "category": "Job"
    },
    {
        "description": "Well Info - Well Location",
        "source": "WELL_LOC variable from 'postRec.cfw' file",
        "type": "string",
        "name": "WellLocation",
        "displayName": "Location",
        "category": "Wellbore"
    },
    {
        "description": "iDistrict well name",
        "displayName": "Well Name",
        "source": "iDistrict API",
        "type": "string",
        "name": "WellName",
        "category": "Well Info"
    },
    {
        "description": "Well Info - Well Name",
        "displayName": "Well Name",
        "coilCatDisplayName": "Well",
        "source": "WELL_NAME variable from 'postRec.cfw' file",
        "type": "string",
        "name": "WellNameCfw",
        "category": "Well Info"
    },
    {
        "description": "Well Info - Well Number",
        "displayName": "UWI/API",
        "coilCatDisplayName": "Well - Legal Description (API Number)",
        "source": "API_WELL_NBR variable from 'postRec.cfw' file",
        "type": "string",
        "name": "WellNumber",
        "category": "Well Info"
    },
    {
        "description": "Well Parameters - Well Type",
        "coilCatDisplayName": "Reservoir - Well Type",
        "displayName": "Well Type",
        "source": "WELL_TYPE variable from 'postRec.cfw' file",
        "type": "string",
        "name": "WellType",
        "category": "Well Info"
    },
    {
        "description": "Windows user running the job uploader",
        "displayName": "Uploaded By",
        "source": "Generated by Job Uploader from client machine registry / environment variables",
        "type": "string",
        "name": "WindowsUser",
        "category": null
    },
    {
        "description": "Casing Grade",
        "source": "CASING_GRADE variable from 'postRec.cfw' file",
        "type": "object",
        "name": "CasingGrade",
        "displayName": "Grade",
        "category": "Casing"
    },
    {
        "description": "BHA Comments",
        "source": "CTBHA_COMPONENT_COMMENTS variable from 'postRec.cfw' file",
        "type": "object",
        "name": "ComponentComments",
        "displayName": "Comments",
        "category": "BHA"
    },
    {
        "description": "BHA Components",
        "source": "CTBHA_COMPONENT_DESCRIPTION variable from 'postRec.cfw' file",
        "type": "object",
        "name": "ComponentDescription",
        "displayName": "Description",
        "category": "BHA"
    },
    {
        "description": "BHA Inner Diameter",
        "source": "CTBHA_COMPONENT_ID_REAL variable from 'postRec.cfw' file",
        "type": "object",
        "name": "ComponentIDReal",
        "displayName": "Inner Diameter",
        "category": "BHA"
    },
    {
        "description": "BHA Section Length",
        "source": "CTBHA_COMPONENT_LENGTH variable from 'postRec.cfw' file",
        "type": "object",
        "name": "ComponentLength",
        "displayName": "Section Length",
        "category": "BHA"
    },
    {
        "description": "BHA Outer Diameter",
        "source": "CTBHA_COMPONENT_OD variable from 'postRec.cfw' file",
        "type": "object",
        "name": "ComponentOD",
        "displayName": "Outer Diameter",
        "category": "BHA"
    },
    {
        "description": "BHA Weight",
        "source": "CTBHA_COMPONENT_WEIGHT variable from 'postRec.cfw' file",
        "type": "object",
        "name": "ComponentWeight",
        "displayName": "Weight",
        "category": "BHA"
    },
    {
        "description": "Fluid Names",
        "source": "FLU_NAME_LONG variable from 'postRec.cfw' file",
        "type": "object",
        "name": "FluidNames",
        "displayName": "Fluid Names",
        "category": null
    },
    {
        "description": "Job Date",
        "displayName": "Job Date",
        "coilCatDisplayName": "Date",
        "source": "DATE_PREPARED variable from 'postRec.cfw' file",
        "type": "string",
        "name": "JobDate",
        "category": "Job"
    },
    {
        "description": "ACTive Toolstring - Tool Names",
        "source": "TOOLSTRCONFIG_TOOL_NAME variable from 'postRec.cfw' file",
        "type": "object",
        "name": "ToolNames",
        "displayName": "Tool Names",
        "category": "ACTive Toolstring"
    },
    {
        "description": "Tubing Grade",
        "source": "TUBING_GRADE variable from 'postRec.cfw' file",
        "type": "object",
        "name": "TubingGrade",
        "displayName": "Grade",
        "category": "Tubing"
    },
    {
        "name": "postJobSdbSha1",
        "description": "SHA1 checksum of '*_aft.sdb' file",
        "source": "Generated by Job Uploader",
        "displayName": "SDB Checksum after Job",
        "category": "System"
    },
    {
        "name": "preJobSdbSha1",
        "description": "SHA1 checksum of '*_bef.sdb' file",
        "source": "Genereted by Job Uploader",
        "displayName": "SDB Checksum before Job",
        "category": "System"
    },
    {
        "name": "stringNameSource",
        "description": "Method used by Job Uploader to determine 'StringName'",
        "source": "CFW variable name used for 'stringName' or '.sdb file name' constant if file name was used",
        "displayName": "String Name Source",
        "category": "System"
    },
    {
        "name": "visibleOnDashboard",
        "description": "Flag that determines if the upload will be visible on the job dashboard",
        "source": "Always set to 1 by Job Uploader",
        "displayName": "Is Visible",
        "category": "System"
    },
    {
        "name": "wellIdSource",
        "description": "Name of the API used get iDistrict data (iDistrict-SIMS/iDistrict-OA)",
        "source": "Set by Job Uploader",
        "displayName": "iDistrict API Name",
        "category": "System"
    }
]
